import { CardElement, AddressElement } from '@stripe/react-stripe-js';
import { Label, Error, ClassHelper, useTranslation } from 'components/lib';
import Style from './input.tailwind.js';

export function CardInput(props){

  const { t } = useTranslation();
  const error = props.errorMessage || t('global.form.card.error');

  const cardStyle = ClassHelper(Style, {

    textbox: true,
    cardbox: true,
    className: props.className,
    error: props.valid === false,

  });

  return (
    <div className={Style.input}>

      <Label
        text={props.label}
        required={props.required}
        for={props.name}
      />

      <CardElement
        className={cardStyle}
        style={{ base: { fontFamily: 'source sans pro', fontSize: '15px' } }}
        options={{
          hidePostalCode: true
        }}
      />

      <AddressElement
        options={{
          mode: 'billing',
          blockPoBox: false,
          defaultValues: {
            address: { country: 'in' },
          },
          display: {
            name: 'full',
          }
        }}
      />

      {props.valid === false && <Error message={error} />}

    </div>
  );
}
